import { useTranslation } from 'react-i18next';
export function CashRecoveryNotice({ error }: { error?: string }) {
  const { t } = useTranslation('accounting');
  return (
    <p role={error ? 'alert' : 'status'} className="text-sm text-warning">
      {t(
        error === 'DENIED'
          ? 'cash.denied'
          : ['SCOPE_REQUIRED', 'EXPIRED', 'SCOPE_MISMATCH', 'VOIDED', 'ALREADY_PREPARED'].includes(
                error ?? '',
              )
            ? `cash.recoveryErrors.${error}`
            : 'cash.uncertain',
      )}{' '}
      {t('cash.investigate')}
    </p>
  );
}
